import { TooltipText } from 'components/shared/TooltipText';
import React from 'react';
import { empty } from '../JsonFrame';
import { JsonContentValidationMessage } from './JsonContentValidationMessage';
import { QueueUxPreferences, SubjectImagePreferences } from 'services';
import { generateImageFilters } from '../../../util/smallFuncs';

interface IframeTypeProps {
  val: string;
  uxPreferences?: QueueUxPreferences;
  settings?: SubjectImagePreferences;
}

export const IframeType: React.FunctionComponent<IframeTypeProps> = (props): JSX.Element => {
  const imageFilter = generateImageFilters(props.settings);
  return !empty(props.val) ? (
    <iframe height="100%" width="100%" src={props.val} title={props.val} style={{ ...imageFilter }} />
  ) : (
    <JsonContentValidationMessage message={TooltipText.iframeTypeValidationMessage} />
  );
};
